export class DeviceAuthorization {
  static async getDeviceAuthorizationKey() {
    return this.sha256Hex(this.getRawDeviceSignature());
  }

  static getRawDeviceSignature() {
    const nav = window.navigator;
    const scr = window.screen;

    const parts = [
      nav.userAgent,
      nav.platform,
      String(nav.hardwareConcurrency ?? ""),
      nav.language,
      String(scr.width),
      String(scr.height),
      String(scr.colorDepth),
      window.Intl.DateTimeFormat().resolvedOptions().timeZone,
      this.getGpuRenderer(),
    ];

    return parts.join("|");
  }

  static getGpuRenderer() {
    try {
      const canvas = document.createElement("canvas");
      const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      if (!gl) return "";

      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      if (!debugInfo) return "";

      return gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
    } catch {
      return "";
    }
  }

  static async sha256Hex(input) {
    const data = new TextEncoder().encode(input);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(digest))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }
}
